import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  min-height: 3rem;
  align-items: center;
  background-color: transparent;

  ul.ul-- {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 0.3rem;
    padding: 0;
    margin: 0;
    list-style: none;
    overflow: visible;
  }
`;

export const DropdownContainer = styled.li`
  position: relative;
  display: flex;
  align-items: center;
  list-style: none;
`;

export const DropdownButton = styled.button`
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  min-width: 2rem;
  height: 2.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #4a5057;
  padding: 0 0.4rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

  &.has-selected {
    border-color: #1D86FF;
    color: #1D86FF;
    background-color: rgba(29, 134, 255, 0.05);
  }

  .more-text {
    font-size: 0.8rem;
    font-weight: 600;
    margin-right: 0.2rem;
  }
`;

export const DropdownContent = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background: white;
  min-width: 14rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  gap: 0.25rem;
  animation: slideIn 0.2s ease-out;
  overflow-y: auto;
  max-height: 250px;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  li {
    width: 100% !important;
    max-width: none !important;
    justify-content: flex-start !important;
    border: none !important;
    background: transparent !important;
    padding: 0.6rem 0.75rem !important;
    height: auto !important;
    border-radius: 0.5rem !important;
    color: #4a5568 !important;
    font-size: 0.85rem !important;
    transition: all 0.15s ease;

    &.selected {
      background-color: #1D86FF !important;
      color: white !important;
    }

    p {
      margin: 0;
      font-size: 0.85rem !important;
    }
  }
`;